window._ = require('lodash');
import { Fancybox } from "@fancyapps/ui";

import menu from "./components/Menu"
import callback from "./components/Callback";
import banner from "./components/Banner";
import swiper from "./components/Swiper";
import collapse from "./components/Collapse";
import scroll from "./components/Scroll";
/*import phone from "./components/Phone";*/
import test from "./components/Test";

try {
    window.$ = window.jQuery = require('jquery');

    /*phone();*/
    menu();
    callback();
    banner();

    swiper();

    collapse();
    scroll();
    test();

} catch (e) {
    console.log(e);
}

Fancybox.bind("[data-fancybox]", {
    helpers: {
        overlay: {
            locked: false
        }
    }
});